import { REPORT_REQUEST_CREATE, REPORT_REQUEST_CREATE_FAIL } from '../action.types';
import InitialState from '../initial.state';

export default (state = InitialState.report, action) => {
    switch (action.type) {
        case REPORT_REQUEST_CREATE:
            return { ...action.payload }
        case REPORT_REQUEST_CREATE_FAIL:
            return state;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/report/report.reducer.js